var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main reg"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"reg__content"},[(_vm.activeStep)?_c(_vm.activeStep.component,{tag:"component",attrs:{"codes":_vm.codes},on:{"changeStep":_vm.setActive}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }